import { render } from "./showCarPart.vue?vue&type=template&id=5f68b0d6&scoped=true"
import script from "./showCarPart.vue?vue&type=script&lang=js"
export * from "./showCarPart.vue?vue&type=script&lang=js"

import "./showCarPart.vue?vue&type=style&index=0&id=5f68b0d6&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f68b0d6"]])

export default __exports__